import React from "react";
import "./sidebar-header.sass";
export const SidebarHeader = ({ title, onIconCLick }) => {
  return /* @__PURE__ */ React.createElement("header", { className: "tint-sidebar-header" }, title && /* @__PURE__ */ React.createElement("h3", null, title), onIconCLick && /* @__PURE__ */ React.createElement("span", { className: "icon fas fa-times", onClick: onIconCLick }));
};
